/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  ConsultantGroup,
  CustomerAccount
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type consultantsListResponse200 = {
  data: ConsultantGroup[]
  status: 200
}

export type consultantsListResponseSuccess = (consultantsListResponse200) & {
  headers: Headers;
};
;

export type consultantsListResponse = (consultantsListResponseSuccess)

export const getConsultantsListUrl = () => {




  return `/api/v1/consultants/`
}

/**
 * Read-only access to ConsultantGroups.
 */
export const consultantsList = async ( options?: RequestInit): Promise<consultantsListResponse> => {

  return customFetch<consultantsListResponse>(getConsultantsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


export type consultantsRetrieveResponse200 = {
  data: ConsultantGroup
  status: 200
}

export type consultantsRetrieveResponseSuccess = (consultantsRetrieveResponse200) & {
  headers: Headers;
};
;

export type consultantsRetrieveResponse = (consultantsRetrieveResponseSuccess)

export const getConsultantsRetrieveUrl = (id: string,) => {




  return `/api/v1/consultants/${id}/`
}

/**
 * Read-only access to ConsultantGroups.
 */
export const consultantsRetrieve = async (id: string, options?: RequestInit): Promise<consultantsRetrieveResponse> => {

  return customFetch<consultantsRetrieveResponse>(getConsultantsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type consultantsByIdRetrieveResponse200 = {
  data: ConsultantGroup
  status: 200
}

export type consultantsByIdRetrieveResponseSuccess = (consultantsByIdRetrieveResponse200) & {
  headers: Headers;
};
;

export type consultantsByIdRetrieveResponse = (consultantsByIdRetrieveResponseSuccess)

export const getConsultantsByIdRetrieveUrl = (id: string,) => {




  return `/api/v1/consultants/by-id/${id}/`
}

/**
 * Retrieve a ConsultantGroup by its ID.
 *
 * This is a public endpoint that returns basic information about a consultant group.
 * Used to support frontend functionality that needs to display consultant group data
 * without requiring authentication.
 */
export const consultantsByIdRetrieve = async (id: string, options?: RequestInit): Promise<consultantsByIdRetrieveResponse> => {

  return customFetch<consultantsByIdRetrieveResponse>(getConsultantsByIdRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type consultantsCustomerAccountsListResponse200 = {
  data: CustomerAccount[]
  status: 200
}

export type consultantsCustomerAccountsListResponseSuccess = (consultantsCustomerAccountsListResponse200) & {
  headers: Headers;
};
;

export type consultantsCustomerAccountsListResponse = (consultantsCustomerAccountsListResponseSuccess)

export const getConsultantsCustomerAccountsListUrl = () => {




  return `/api/v1/consultants/customer-accounts/`
}

/**
 * Get all customer accounts for the authenticated consultant
 *
 * Only consultant users can access this endpoint.
 */
export const consultantsCustomerAccountsList = async ( options?: RequestInit): Promise<consultantsCustomerAccountsListResponse> => {

  return customFetch<consultantsCustomerAccountsListResponse>(getConsultantsCustomerAccountsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


